import React from 'react';
import { Skeleton, Stack } from '@mui/material';

export const DealBuilderSkeleton = () => {
  return (
    <Stack gap={2} height="100%" width="100%">
      <Skeleton variant="rounded" height={100} />
      <Skeleton variant="rounded" height={100} />
      <Skeleton variant="rounded" height="100%" />
    </Stack>
  );
};
